import { IconWrapper, NoteText, Wrapper } from './InfoNote.styles';
import type { InfoNoteProps } from './InfoNote.types';

export function InfoNote({ text, icon, variant = 'neutral' }: InfoNoteProps) {
  return (
    <Wrapper $variant={variant}>
      {icon && <IconWrapper $variant={variant}>{icon}</IconWrapper>}
      <NoteText $variant={variant}>{text}</NoteText>
    </Wrapper>
  );
}
